var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-param-reassign */
import { useState, useEffect } from 'react';
import { GetDeliveryTrackerAPI } from '../api/oms/common';
import { getSvocId } from '../utils/user';
import { newrelic } from '../utils/newrelic';
import { buildSTHDeliveryTrackerItems } from '../utils/order-details/OrderDetailsUtils';
export var GetDeliveryTrackerInfo = function (orderDetailsData) { return __awaiter(void 0, void 0, void 0, function () {
    var orderNumber, deliveryTrackerData, logDeliveryTrackerFailure;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!orderDetailsData) {
                    return [2 /*return*/, undefined];
                }
                orderNumber = orderDetailsData.orderNumber;
                deliveryTrackerData = structuredClone(orderDetailsData);
                logDeliveryTrackerFailure = function (error, deliveryTrackerRequest) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    var status = ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString()) || '';
                    var errorDetails = (_e = (_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e[0];
                    var errorCode = ((_f = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.code) === null || _f === void 0 ? void 0 : _f.toString()) || '';
                    var errorDescription = (errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.description) || '';
                    var workOrderNumber = ((_g = deliveryTrackerRequest === null || deliveryTrackerRequest === void 0 ? void 0 : deliveryTrackerRequest.deliveryTrackerRequest) === null || _g === void 0 ? void 0 : _g.workOrderNumber) || '';
                    var trackingNumber = ((_h = deliveryTrackerRequest === null || deliveryTrackerRequest === void 0 ? void 0 : deliveryTrackerRequest.deliveryTrackerRequest) === null || _h === void 0 ? void 0 : _h.trackingNumber) || '';
                    newrelic.addPageAction('deliveryTrackerApiFailure', {
                        orderNumber: orderNumber,
                        workOrderNumber: workOrderNumber,
                        trackingNumber: trackingNumber,
                        status: status,
                        errorCode: errorCode,
                        errorDescription: errorDescription,
                    });
                };
                ((_a = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.fulfillmentGroups) !== null && _a !== void 0 ? _a : []).forEach(function (fulfillmentGroup) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                    var requestFulfillmentType = {
                        ShipToHome: 'STH',
                        BuyOnlineShipToStore: 'BOSS',
                        BuyOnlineDeliverFromStore: 'BODFS',
                        DFS: 'DFS',
                        Appliance: 'MA',
                        BuyOnlinePickupInStore: 'BOPIS',
                        '': undefined,
                    }[(_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType) !== null && _a !== void 0 ? _a : ''];
                    var trackingNumber = (_f = (_e = (_d = (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _b === void 0 ? void 0 : _b.shipments) === null || _c === void 0 ? void 0 : _c.shipment) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.trackingNumber) !== null && _f !== void 0 ? _f : null;
                    var workOrderNumber = ((_j = (_h = (_g = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _g === void 0 ? void 0 : _g.applianceDeliveries) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.workOrderNo) ||
                        ((_m = (_l = (_k = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _k === void 0 ? void 0 : _k.bodfsDeliveries) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.workOrderNo) ||
                        null;
                    var invalidFulfillmentTypes = [
                        'Additional Items',
                        'BOPIS',
                        'BuyOnlinePickupInStore',
                        'InStorePurchase',
                        'MISC',
                        'unavailable',
                    ].includes((_o = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType) !== null && _o !== void 0 ? _o : '');
                    if (['Canceled', 'Returned', 'Return Initiated', 'ReturnInProgress'].includes((_r = (_q = (_p = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _p === void 0 ? void 0 : _p[0]) === null || _q === void 0 ? void 0 : _q.statusDescription) !== null && _r !== void 0 ? _r : '') ||
                        invalidFulfillmentTypes) {
                        fulfillmentGroup.deliveryTrackerData = null;
                    }
                    if ((trackingNumber || workOrderNumber) && !invalidFulfillmentTypes) {
                        var lineItems = buildSTHDeliveryTrackerItems(fulfillmentGroup);
                        fulfillmentGroup.deliveryTrackerData = {
                            deliveryTrackerRequest: {
                                customerId: (_s = getSvocId()) !== null && _s !== void 0 ? _s : 'guest',
                                fulfillmentType: requestFulfillmentType !== null && requestFulfillmentType !== void 0 ? requestFulfillmentType : null,
                                orderNumber: orderNumber !== null && orderNumber !== void 0 ? orderNumber : null,
                                trackingNumber: trackingNumber,
                                workOrderNumber: workOrderNumber,
                                lineItems: lineItems,
                            },
                        };
                    }
                    else {
                        fulfillmentGroup.deliveryTrackerData = null;
                    }
                });
                if (!(((_c = (_b = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.fulfillmentGroups) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0)) return [3 /*break*/, 2];
                return [4 /*yield*/, Promise.allSettled((_d = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.fulfillmentGroups) === null || _d === void 0 ? void 0 : _d.map(function (fulfillmentGroup) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, error_1;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (fulfillmentGroup.deliveryTrackerData === null) {
                                        fulfillmentGroup.deliveryTrackerLoaded = true;
                                        return [2 /*return*/];
                                    }
                                    if (!((fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.deliveryTrackerData) &&
                                        typeof fulfillmentGroup.deliveryTrackerData !== 'string' &&
                                        'deliveryTrackerRequest' in fulfillmentGroup.deliveryTrackerData)) return [3 /*break*/, 5];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, 4, 5]);
                                    return [4 /*yield*/, GetDeliveryTrackerAPI(fulfillmentGroup.deliveryTrackerData)];
                                case 2:
                                    response = _b.sent();
                                    response.data.traceId = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.traceid;
                                    fulfillmentGroup.deliveryTrackerData = response.data;
                                    fulfillmentGroup.deliveryTrackerLoaded = true;
                                    return [3 /*break*/, 5];
                                case 3:
                                    error_1 = _b.sent();
                                    logDeliveryTrackerFailure(error_1, fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.deliveryTrackerData);
                                    fulfillmentGroup.deliveryTrackerData = null;
                                    fulfillmentGroup.deliveryTrackerLoaded = true;
                                    return [3 /*break*/, 5];
                                case 4:
                                    fulfillmentGroup.deliveryTrackerLoaded = true;
                                    return [7 /*endfinally*/];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 1:
                _e.sent();
                return [2 /*return*/, deliveryTrackerData];
            case 2: return [2 /*return*/, deliveryTrackerData];
        }
    });
}); };
export var FetchDeliveryTrackerInfo = function (request) {
    var _a, _b, _c;
    var _d = useState(null), deliveryTrackerData = _d[0], setDeliveryTrackerData = _d[1];
    var _e = useState(null), deliveryTrackerError = _e[0], setDeliveryTrackerError = _e[1];
    var _f = useState(false), deliveryTrackerLoaded = _f[0], setDeliveryTrackerLoaded = _f[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!request) {
                            setDeliveryTrackerLoaded(true);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, GetDeliveryTrackerAPI(request)];
                    case 2:
                        response = _b.sent();
                        response.data.traceId = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.traceid;
                        setDeliveryTrackerData(response.data);
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _b.sent();
                        setDeliveryTrackerError(error_2);
                        return [3 /*break*/, 5];
                    case 4:
                        setDeliveryTrackerLoaded(true);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [
        (_a = request === null || request === void 0 ? void 0 : request.deliveryTrackerRequest) === null || _a === void 0 ? void 0 : _a.orderNumber,
        (_b = request === null || request === void 0 ? void 0 : request.deliveryTrackerRequest) === null || _b === void 0 ? void 0 : _b.trackingNumber,
        (_c = request === null || request === void 0 ? void 0 : request.deliveryTrackerRequest) === null || _c === void 0 ? void 0 : _c.workOrderNumber,
    ]);
    return {
        deliveryTrackerData: deliveryTrackerData,
        deliveryTrackerError: deliveryTrackerError,
        deliveryTrackerLoaded: deliveryTrackerLoaded,
    };
};
